<div class="footer-info">
  <app-text
    text="Políticas de privacidad / T&C"
    [fontSize]="10"
    [lineHeight]="10"
    colorClass="color-gray-200"
    [customStyles]="{ marginRight: '10px' }"
  >
  </app-text>

  <app-text
    text="© Copyright 2022 Redeban. "
    [fontSize]="10"
    [lineHeight]="10"
    colorClass="color-secondary-400"
    [customStyles]="{ marginRight: '3px' }"
  >
  </app-text>

  <app-text
    text=" Todos los derechos reservados"
    [fontSize]="10"
    [lineHeight]="10"
    colorClass="color-gray-200"
  >
  </app-text>
</div>
